<template>
  <div class="page b1">
    <div class="container">
      <div class="split-line"></div>
      <div class="tab-row mt-30 mb-20">
        <ul>
          <li
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ 'tab-selected': currentSelectedTabIndex === index }"
            @click="changeTab(index)"
          >{{ item.name }}</li>
        </ul>
      </div>
      <div class="split-line"></div>
      <div v-show="currentSelectedTabIndex === 0" class="tab-pane-repo">
        <div class="summary-info ml-30 mt-40">
          <div>
            <span class="summary-info-name s8 t1 fw-b">锦囊概况</span>
            <span class="s4 t3">(初始资金100W)</span>
          </div>
          <div class="flx mt-40">
            <div class="flx-equals-item s4 t3">总资产</div>
            <div class="flx-equals-item s4 t3">可用</div>
          </div>
          <div class="flx mt-20">
            <div
              class="flx-equals-item s10 t1 fw-b"
            >{{ formatMoney(jinNangDetail.totalAmount) }}</div>
            <div
              class="flx-equals-item s10 t1 fw-b"
            >{{ formatMoney(jinNangDetail.avaliableAmount) }}</div>
          </div>
          <div class="flx mt-40">
            <div class="flx-equals-item s4 t3">账户市值</div>
            <div class="flx-equals-item s4 t3">仓位</div>
          </div>
          <div class="flx mt-20 mb-40">
            <div
              class="flx-equals-item s10 t1 fw-b"
            >{{ formatMoney(jinNangDetail.marketValueAmount) }}</div>
            <div
              class="flx-equals-item s10 t1 fw-b"
            >{{ jinNangDetail.totalPosition }}</div>
          </div>
          <!-- <div class="rate-wrap">
          <div class="split-line"></div>

          <div class="flx mt-30">
            <div class="flx-equals-item s4 t3">周收益</div>
            <div class="flx-equals-item s4 t3">月收益</div>
            <div class="flx-equals-item s4 t3">年收益</div>
            <div class="flx-equals-item s4 t3">总收益</div>
          </div>
          <div class="flx mt-20 mb-20">
            <div
              class="flx-equals-item s4"
              :class="[getSymbol(jinNangDetail.weekYeild) > 0 ? 'c1' : 'c3']"
            >
              {{ jinNangDetail.weekYeild }}
            </div>
            <div
              class="flx-equals-item s4"
              :class="[getSymbol(jinNangDetail.monthYeild) > 0 ? 'c1' : 'c3']"
            >
              {{ jinNangDetail.monthYeild }}
            </div>
            <div
              class="flx-equals-item s4"
              :class="[getSymbol(jinNangDetail.yearYeild) > 0 ? 'c1' : 'c3']"
            >
              {{ jinNangDetail.yearYeild }}
            </div>
            <div
              class="flx-equals-item s4"
              :class="[getSymbol(jinNangDetail.totalYeild) > 0 ? 'c1' : 'c3']"
            >
              {{ jinNangDetail.totalYeild }}
            </div>
          </div>
          </div>-->
          <div class="split-line-20"></div>
          <div class="trade-time-wrap">
            <span class="sp-last-trade trade-icon"></span>
            <span class="s8 t1">最近交易</span>
            <span class="s8 t1 ml-20">
              {{
              convertTime(jinNangDetail.latestTradeTime)
              }}
            </span>
            <span class="s8 t1 ml-14">
              {{
              convertTimeShort(jinNangDetail.latestTradeTime)
              }}
            </span>
          </div>
          <div class="split-line"></div>
          <div class="trade-time-wrap">
            <span class="sp-first-trade trade-icon"></span>
            <span class="s8 t1">初次交易</span>
            <span class="s8 t1 ml-20">
              {{
              convertTime(jinNangDetail.firstTradeTime)
              }}
            </span>
            <span class="s8 t1 ml-14">
              {{
              convertTimeShort(jinNangDetail.firstTradeTime)
              }}
            </span>
          </div>
          <div class="split-line-20"></div>
          <div class="trade-item-table">
            <div class="table-head s4 t3 border-1px-b">
              <div>名称</div>
              <div>持仓/可用</div>
              <div>现价/成本(元)</div>
              <div>持仓盈亏</div>
            </div>
            <div
              class="table-row border-1px-b"
              v-for="(item, index) in repoList"
              :key="index"
            >
              <div>
                <div class="s8 t1">{{ item.securitiesName }}</div>
                <div class="s4 t3">{{ item.securitiesCode }}</div>
              </div>
              <div>
                <div class="s10 t1">{{ item.secuAmount }}</div>
                <div class="s4 t3">{{ item.usableAmount }}</div>
              </div>
              <div>
                <div class="s10 t1">{{ item.newPriceStr }}</div>
                <div class="s4 t3">{{ item.dilucostPriceStr }}</div>
              </div>
              <div>
                <div
                  class="s10 c3"
                  :class="{ 'positive-color': isPositive(item.gainLossScale) }"
                >{{ item.gainLossScale }}</div>
                <div class="s4 t3">{{ item.totalGailLoss/10000}}</div>
              </div>
            </div>
          </div>
          <div class="split-line-20"></div>
          <div class="repo-chart-container flx-col mt-40">
            <!-- 仓位配置 -->
            <div class="s8 t1 fw-b">仓位配置</div>

            <div id="repoChart" class="repo-chart"></div>
          </div>
        </div>
      </div>
      <div v-show="currentSelectedTabIndex === 1" class="tab-pane-trade">
        <van-list
          v-model="loading"
          :finished="pageEnd"
          finished-text="加载完毕"
          @load="onLoad"
        >
          <div
            class="trade-list-item flx-col"
            v-for="(firstItem, firstIndex) in handleTradeList"
            :key="firstIndex"
          >
            <div
              class="mt-30 ml-30 s5 t3"
            >{{ convertTime(firstItem.allData[0].tradeTime) }}</div>
            <div
              class="table-trade b1 border-1px-b s6"
              v-for="(item, index) in firstItem.allData"
              :key="index"
            >
              <div class="left">
                <span
                  class="sp-trade-type-icon"
                  :class="{
                'trade-type-1': item.tradeType === 1,
                'trade-type-2': item.tradeType === 2
              }"
                ></span>
              </div>
              <div class="center">
                <div class="line-content">
                  <div class="name-wrap first fw-b s8 t1">
                    <div class="font">{{ item.secuName }}</div>
                    <div class="number">{{ item.secuCode }}</div>
                  </div>
                  <div class="name-wrap second">
                    <span class="font t3">成交时间</span>
                    <span
                      class="number t1"
                    >{{ convertTimeShort(item.tradeTime) }}</span>
                  </div>
                </div>
                <div class="line-content">
                  <div class="name-wrap first">
                    <div class="font t3">成交价</div>
                    <div class="number t1">{{ item.dealPriceStr }}</div>
                  </div>
                  <div class="name-wrap second">
                    <div class="font t3">成交股数</div>
                    <div class="number t1">{{ item.dealNumber }}</div>
                  </div>
                </div>
                <div
                  class="line-content"
                  v-if="checkbox.includes((firstIndex*firstItem.allData.length)+index)"
                >
                  <div class="name-wrap first">
                    <div class="font t3">成交额</div>
                    <div class="number t1">{{ item.dealAmountStr }}</div>
                  </div>
                  <div class="name-wrap second">
                    <div class="font t3">成交占比</div>
                    <div class="number t1">{{ item.dealPosition }}</div>
                  </div>
                </div>
              </div>
              <div
                class="right"
                :class="{ up: !checkbox.includes((firstIndex*firstItem.allData.length)+index) }"
                @click="check((firstIndex*firstItem.allData.length)+index)"
              ></div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  getJinNangRepoList,
  getJinNangDetail,
  getJinNangTradePage
} from '@/api/jinNang'
import { unitToPx } from '@/util/unit'
export default {
  name: 'JinNangMoreDetail',
  data() {
    return {
      currentSelectedTabIndex: parseInt(this.$route.query.activeIndex) || 0,
      tabList: [
        { name: '持仓明细', index: 0 },
        { name: '交易动态', index: 1 }
      ],
      tradeList: [],
      handleTradeList: [],
      repoList: [],
      viewState: '',
      //   jinNangId: '2010004534',
      jinNangDetail: {},
      checkbox: [0],
      pageEnd: false,
      loading: false
    }
  },
  created() {
    this.getJinNangPage().then(() => this.getJinNangRepoList())
  },
  computed: {
    jinNangId() {
      return this.$route.params.id
    }
  },
  methods: {
    check(i) {
      var idx = this.checkbox.indexOf(i)
      if (idx > -1) {
        this.checkbox.splice(idx, 1)
      } else {
        this.checkbox.push(i)
      }
    },
    async onLoad() {
      await this.getTradePage()
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    changeTab(index) {
      this.currentSelectedTabIndex = index
    },
    isPositive(str) {
      const pos = str.indexOf('-')
      return pos < 0
    },
    convertTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    convertTimeShort(time) {
      return dayjs(time).format('HH:mm:ss')
    },
    toThousands(num) {
      const result = []
      let counter = 0
      num = (num || 0).toString().split('')
      for (let i = num.length - 1; i >= 0; i--) {
        counter++
        result.unshift(num[i])
        if (!(counter % 3) && i !== 0) {
          result.unshift(',')
        }
      }
      return result.join('')
    },
    formatMoney(num) {
      if (typeof num === typeof undefined) {
        return NaN
      }
      return (num / 10000)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    async getTradePage() {
      this.loading = true
      const data = await getJinNangTradePage(
        {
          jinNangId: this.jinNangId,
          direction: this.viewState ? 2 : 0,
          filter: 1
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          if (data.detail.flush) {
            this.tradeList = data.detail.list
          } else {
            this.tradeList = this.tradeList.concat(data.detail.list)
          }
          this.handleTradeList = this.dealWithData(this.tradeList)

          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end
          this.loading = false
        }
      }
    },
    dealWithData(data) {
      const c = []
      const d = {}
      data.forEach(element => {
        let tradeTime = dayjs(element.tradeTime).format('YYYYMMDD')
        if (!d[tradeTime]) {
          c.push({
            time: tradeTime,
            allData: [element]
          })
          d[tradeTime] = element
        } else {
          c.forEach(ele => {
            if (ele.time === tradeTime) {
              ele.allData.push(element)
            }
          })
        }
      })
      return c
    },
    async getJinNangRepoList() {
      const data = await getJinNangRepoList({
        jinNangId: this.jinNangId
      })
      if (data) {
        if (data.result.code === 0) {
          this.repoList = data.detail.items
          this.renderRepoChart(this.repoList)
        }
      }
    },
    async getJinNangPage() {
      this.jinNangDetail = await getJinNangDetail({
        jinNangId: this.jinNangId
      })
      document.title = '锦囊-' + this.jinNangDetail.jinNangName
      await this.getTradePage()
    },
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach(item => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
    renderRepoChart(sourceData) {
      var yieldChart = this.$echarts.init(
        document.getElementById('repoChart'),
        '',
        {
          width: window.innerWidth + 'px'
        }
      )
      var industryGroup = this.groupBy(sourceData, x => x.industryName)
      var seriesData = []
      const legendData = []
      let allSumVal = 0

      industryGroup.forEach((val, key) => {
        legendData.push(key)

        var sumVal = val.reduce(
          (pre, cur) => pre + cur.marketValue / 10000.0,
          0
        )
        seriesData.push({
          value: sumVal,
          name: key
        })
      })

      allSumVal = seriesData.reduce((pre, cur) => pre + cur.value, 0)
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:{d}%'
        },
        grid: {
          top: 0,
          bottom: 0
        },
        legend: {
          type: 'scroll',
          height: '120px',
          data: legendData,
          top: 'middle',
          orient: 'vertical',
          right: unitToPx('0.5rem'),
          icon: 'circle',
          formatter: name => {
            var val = seriesData.find(a => a.name === name).value
            // 拼接全角空白符，为了使百分比对齐
            var emtpy = new Array(8 - name.length).join('　')
            return name + emtpy + ((val / allSumVal) * 100).toFixed(2) + '%'
          },
          textStyle: {
            fontSize: 12,
            color: 'rgba(38,38,38,1.000)',
            textAlign: 'right'
          }
        },
        series: [
          {
            type: 'pie',
            radius: [unitToPx('0.56rem'), unitToPx('1.2rem')],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: seriesData,
            center: [unitToPx('1.86rem'), '50%'],
            markPoint: {
              symbolSize: 0.01,
              data: [
                {
                  x: unitToPx('1.86rem'),
                  y: '52%',
                  verticalAlign: 'middle',
                  label: {
                    width: 50,
                    formatter: `{a|${this.jinNangDetail.totalPosition}\n}{b|总仓位}`,
                    color: '#000',
                    rich: {
                      a: {
                        color: '#262626',
                        fontSize: 12,
                        lineHeight: 14,
                        align: 'center'
                      },
                      b: {
                        color: '#858585',
                        fontSize: 10,
                        lineHeight: 14,
                        align: 'center'
                      }
                    }
                  }
                }
              ]
            }
          }
        ]
      }

      yieldChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
#repoChart {
  width: 750px;
}
.rate-wrap {
  padding: 0 56px 0 20px;
  .split-line {
    margin: 0 -26px;
  }
  // text-align: center;
  .flx {
    justify-content: space-between;
  }
  .flx-equals-item {
    flex: none;
  }
}
.container {
  display: flex;
  flex-direction: column;
}
.tab-row ul {
  display: flex;
  justify-content: center;
}
.tab-row ul li {
  display: inline-block;
  flex: auto;
  text-align: center;
  cursor: pointer;
}
.tab-selected {
  color: #046bcc;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 64px;
    height: 8px;
    background-color: #046bcc;
    border-radius: 5px;
  }
}
.tab-pane-repo,
.tab-pane-trade {
  display: flex;
  flex-direction: column;
}
.flx-equals-item {
  // flex-grow: 1;
  flex: 1;
}
.sp-first-trade {
  background: url('./images/firstTrade.png') no-repeat;
}
.sp-last-trade {
  background: url('./images/lastTrade.png') no-repeat;
}
.trade-time-wrap {
  display: flex;
  height: 88px;
  align-items: center;
}
.trade-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
  background-size: cover;
  background-position: center;
}
.trade-item-table {
  padding-right: 30px;
}
.table-row {
  display: flex;
  height: 120px;
  justify-content: center;
  &:last-child::after {
    border: none;
  }
}
.table-head {
  height: 60px;
  display: flex;
  font-size: 24px;
  color: #858585;
  margin: 0 -30px;
  padding: 0 30px;
}
.table-head,
.table-row {
  > div {
    flex: 5;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    align-content: center;
    &:first-child {
      align-items: flex-start;
    }
    & > :nth-child(2) {
      margin-top: 10px;
    }
    &:nth-child(2) {
      flex: 3;
    }
  }
}
.repo-chart-container {
  background-color: #ffffff;
}
.repo-chart {
  margin-left: -30px;
  height: 300px;
  //margin-left: 66px;
  margin-top: 30px;
}
.trade-time {
  display: flex;
  align-items: center;
  line-height: normal;
  height: 60px;
}
.table-trade {
  padding: 40px 30px 40px 30px;
  display: flex;
  .left {
    margin-right: 10px;
  }
  .center {
    flex: 1;
  }
  .line-content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    &:last-child {
      padding-bottom: 0;
    }
    // text-align: left;
    .name-wrap {
      display: flex;
      // justify-content: space-between;
    }
    .first {
      width: 302px;
      .font {
        margin-right: 12px;
      }
    }
    .second {
      flex: 1;
      .font {
        margin-right: 12px;
      }
    }
  }
  .right {
    width: 20px;
    height: 56px;
    background: url('./images/close.png') no-repeat center center;
    background-size: 20px 12px;
    margin: auto 0 auto 30px;
    &.up {
      transform: rotate(180deg);
    }
  }
}
.trade-type-1 {
  background: url('./images/tradeType1.png') no-repeat;
}
.trade-type-2 {
  background: url('./images/tradeType2.png') no-repeat;
}
.sp-trade-type-icon {
  height: 35px;
  min-width: 65px;
  display: inline-block;
  vertical-align: middle;
  background-size: cover;
  background-position: center;
}
.positive-color {
  color: #e64c2e;
}
.negative-color {
  color: #38bf26;
}
.positive-color {
  color: #e64c2e;
}
.negative-color {
  color: #38bf26;
}
.flx {
  display: flex;
}
.flx-col {
  display: flex;
  flex-direction: column;
}
.split-line {
  height: 1px;
  background-color: #ebebeb;
}
.split-line-20 {
  margin-left: -30px;
  height: 20px;
  background-color: #f0f0f0;
}
.mr-10 {
  margin-right: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.mr-30 {
  margin-right: 30px;
}
.fw-b {
  font-weight: bold;
}
.fl-l {
  float: left;
}
.fl-r {
  float: right;
}

.summary-info-name {
  display: inline-block;
  margin-right: 20px;
}
</style>
